import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { Replay } from "@sentry/replay";
import reportWebVitals from "./reportWebVitals";
// localStorage を直接使用するため、設定は不要

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// Sentry セットアップ（DSN が設定されている場合のみ有効）
if (process.env.REACT_APP_SENTRY_DSN) {
  const tracesSampleRate = Number(
    process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.0"
  );
  const replaysSessionSampleRate = Number(
    process.env.REACT_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || "0.0"
  );
  const replaysOnErrorSampleRate = Number(
    process.env.REACT_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || "1.0"
  );
  const debug = String(process.env.REACT_APP_SENTRY_DEBUG || "false") === "true";

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [
      new BrowserTracing(),
      ...(replaysSessionSampleRate > 0 || replaysOnErrorSampleRate > 0
        ? [new Replay()]
        : []),
    ],
    environment: process.env.REACT_APP_SENTRY_ENV || process.env.NODE_ENV,
    tracesSampleRate,
    // リプレイは必要に応じて有効化
    replaysSessionSampleRate,
    replaysOnErrorSampleRate,
    debug,
  });

  // 簡易テスト用フック（開発時に DevTools で window.__SENTRY_TEST__() を呼ぶ）
  try {
    (window as any).__SENTRY_TEST__ = () => {
      Sentry.captureMessage("sentry-selftest: manual trigger");
    };
  } catch (_) {
    void 0; // no-op if setting test hook fails
  }
}
